import { useState, useEffect } from "react";
import { Users, Zap, Mail, Shield, FileText } from "lucide-react";

const statConfigs = [
  { icon: Zap, label: "tests today", baseValue: 847, increment: { min: 1, max: 3 }, interval: 4000 },
  { icon: Mail, label: "emails analyzed", baseValue: 1234, increment: { min: 2, max: 5 }, interval: 3500 },
  { icon: Shield, label: "domains checked", baseValue: 523, increment: { min: 1, max: 2 }, interval: 5000 },
  { icon: FileText, label: "headers parsed", baseValue: 312, increment: { min: 1, max: 3 }, interval: 4500 },
];

export const LiveStatsCounter = () => {
  const [statValues, setStatValues] = useState(statConfigs.map(s => s.baseValue));
  const [helpedCount, setHelpedCount] = useState(1247);
  const [currentStatIndex, setCurrentStatIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  
  // Increment stats randomly
  useEffect(() => {
    const intervals = statConfigs.map((config, index) => 
      setInterval(() => {
        setStatValues(prev => {
          const updated = [...prev];
          updated[index] += Math.floor(Math.random() * (config.increment.max - config.increment.min + 1)) + config.increment.min;
          return updated;
        });
      }, config.interval + Math.random() * 2000)
    );
    
    // Slowly increment helped count
    const helpedInterval = setInterval(() => {
      setHelpedCount(prev => prev + (Math.random() > 0.6 ? 1 : 0));
    }, 10000 + Math.random() * 5000);
    
    return () => {
      intervals.forEach(clearInterval);
      clearInterval(helpedInterval);
    };
  }, []);

  // Cycle through different stats
  useEffect(() => {
    const cycleInterval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentStatIndex(prev => (prev + 1) % statConfigs.length);
        setIsTransitioning(false);
      }, 200);
    }, 6000);
    
    return () => clearInterval(cycleInterval);
  }, []);

  const currentStat = statConfigs[currentStatIndex];
  const CurrentIcon = currentStat.icon;

  // Format helped count nicely (1.2k format)
  const formatHelpedCount = (count: number) => {
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}k`;
    }
    return count.toString();
  };

  return (
    <div className="fixed bottom-4 right-4 z-40 pointer-events-none">
      <div className="pointer-events-auto">
        <div className="bg-card/90 backdrop-blur-sm border border-border/40 rounded-lg px-3 py-2 shadow-md">
          <div className="flex items-center gap-4 text-xs">
            <div className={`flex items-center gap-1.5 transition-opacity duration-200 ${isTransitioning ? 'opacity-0' : 'opacity-100'}`}>
              <div className="relative">
                <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse" />
              </div>
              <CurrentIcon className="w-3 h-3 text-primary" />
              <span className="tabular-nums font-medium text-foreground">{statValues[currentStatIndex].toLocaleString()}</span>
              <span className="text-muted-foreground">{currentStat.label}</span>
            </div>
            <div className="w-px h-3 bg-border" />
            <div className="flex items-center gap-1.5">
              <Users className="w-3 h-3 text-success" />
              <span className="text-muted-foreground">Helped</span>
              <span className="tabular-nums font-medium text-foreground">{formatHelpedCount(helpedCount)}</span>
              <span className="text-muted-foreground">this month</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
